import { Hero, Services, Why, How, SampleReport, MeetAline, Reviews, Investors, AreasBlock, FaqBlock } from "@/components/home/HomeSections";
import { FinalCta } from "@/components/home/FinalCta";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Services />
      <Why />
      <How />
      <SampleReport />
      <MeetAline />
      <Reviews />
      <Investors />
      <AreasBlock />
      <FaqBlock />
      <FinalCta />
    </div>
  );
}
